import * as React from 'react';
import styled from 'styled-components';
import { XIAnimation, ToolTipContent, SnackBarProps } from '@inmoment/the-kitchen';

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
`;

export const patternLoading: SnackBarProps = {
  id: (new Date().valueOf() * Math.random() * 100).toString(),
  text: 'Fetching Pattern Templates ...',
  actionText: 'Dismiss',
  autoDismiss: true,
  dismissTime: 3000,
  mode: 'default',
};
export const patternLoadingSuccess: SnackBarProps = {
  id: (new Date().valueOf() * Math.random() * 100).toString(),
  text: 'Success!',
  actionText: 'Dismiss',
  autoDismiss: true,
  dismissTime: 3000,
  mode: 'default',
};
export const errorObj = (value: string): SnackBarProps => {
  return {
    id: new Date().toString(),
    text: `An error occurred fetching ${value}. Are you connected to the VPN? If so, reach out to the Kitchen Team if this issue persists.`,
    actionText: 'Dismiss',
    autoDismiss: false,
    dismissTime: 3000,
    mode: 'error',
  };
};

export const parseUpdates = (updates: any, backendUpdates: any) => {
  for (let key in backendUpdates) {
    if (backendUpdates[key].date) {
      const { updates: versionUpdates } = backendUpdates[key];
      const fixed: any[] = [];
      const added: any[] = [];

      if (versionUpdates) {
        versionUpdates.forEach((item: any) => {
          const link = item.title
            .match(/\[.*\]/)[0]
            .replace('[', '')
            .replace(']', '');

          if (item.title.includes('BZ')) {
            fixed.push({ title: item.title, description: item.description, link });
          } else {
            added.push({ title: item.title, description: item.description, link });
          }
        });
        updates.unshift({
          version: key,
          versionDate: backendUpdates[key].date,
          versionUpdates: {
            fixed: fixed.length ? fixed : undefined,
            added: added.length ? added : undefined,
          },
        });
      }
    }
  }

  return updates.sort((a: any, b: any) => new Date(b.versionDate).valueOf() - new Date(a.versionDate).valueOf());
};

export const NewUpdate = (item: any) => (
  <ToolTipContent
    tooltip={{ text: item.description, direction: 6 }}
    text={item.title}
    link={`https://jira.inmoment.com/browse/${item.link}`}
    style={{ position: 'relative' }}
  >
    <p className="kxi-text-normal orca">{item.title}</p>;
  </ToolTipContent>
);

export const FetchingUpdates = () => (
  <LoadingWrapper>
    <XIAnimation animation="admin_loader" />
    <p className="orca kxi-text-600 kxi-text-xlarge">Fetching Updates ...</p>
  </LoadingWrapper>
);
